import React from 'react';
import moment from 'moment';

export default function NextEpisode({ time }) {
  return time ? (
    <span className="episode__release-date">Next Episode: {moment(time).format('MMM Do @ h:mma')}</span>
  ) : null;
}



// WEBPACK FOOTER //
// ./src/subscription/tv/common/NextEpisode.js